export default Object.freeze({
    NO_DRAGON: 'NO DRAGON',
    DRAGON: 'DRAGON'
})
